// extracted by mini-css-extract-plugin
export default {"button":"_2yH3g","wrapper":"_2s8kL","label":"_2PKeI","bubble":"_2ya4U"};